export const SEARCH_CUSTOMERS_REQUEST_DATA = "SEARCH_CUSTOMERS_REQUEST_DATA";
export const SEARCH_CUSTOMERS_RECEIVE_DATA = "SEARCH_CUSTOMERS_RECEIVE_DATA";
export const SEARCH_CUSTOMERS_REQUEST_DATA_FAILED = "SEARCH_CUSTOMERS_REQUEST_CURRENCY_DATA_FAILED";

export const receiveData = (data) => ({ type: SEARCH_CUSTOMERS_RECEIVE_DATA, payload: data });
export const requestFailed = (error) => ({ type: SEARCH_CUSTOMERS_REQUEST_DATA_FAILED, payload: error });
